import { create } from 'zustand'
import {
  buildHeaderNavLabelMaps,
  getChildNavLabel,
  getParentNavLabel,
  resolveHeaderFeatureCatalog,
} from '../utility/headerNavLabels'

const EMPTY_NAV_LABEL_MAPS = {
  parentByFeatureKey: {},
  childByFeatureKey: {},
}

const buildNavLabelMaps = (featureDefinitions = []) =>
  buildHeaderNavLabelMaps(resolveHeaderFeatureCatalog(featureDefinitions))

export const useUserFeatureStore = create((set) => ({
  featureDefinitions: [],
  navLabelMaps: EMPTY_NAV_LABEL_MAPS,
  setFeatureDefinitions: (featureDefinitions = []) => {
    const normalized = Array.isArray(featureDefinitions) ? featureDefinitions : []

    set({
      featureDefinitions: normalized,
      navLabelMaps: buildNavLabelMaps(normalized),
    })
  },
  resetUserFeatureStore: () =>
    set({
      featureDefinitions: [],
      navLabelMaps: EMPTY_NAV_LABEL_MAPS,
    }),
}))

export const setUserFeatureDefinitions = (featureDefinitions = []) => {
  useUserFeatureStore.getState().setFeatureDefinitions(featureDefinitions)
}

export const resetUserFeatureStore = () => {
  useUserFeatureStore.getState().resetUserFeatureStore()
}

export const getStoredParentNavLabel = (featureKey, fallback = '') =>
  getParentNavLabel(featureKey, useUserFeatureStore.getState().navLabelMaps, fallback)

export const getStoredChildNavLabel = (featureKey, fallback = '') =>
  getChildNavLabel(featureKey, useUserFeatureStore.getState().navLabelMaps, fallback)
